import { AppState } from '../../index';

export const wishListSelector = (state: AppState) => {
   return state.wishlist
}